import styled from 'styled-components'

export const ModalBackPrompt = styled.div`
  max-width: 550px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  p {
    width: 100%;
  }

  i.fa-sign-out {
    transform: scaleX(-1);
    margin-right: 10px;
  }
`
